import moment from 'moment';
import formatters from 'common/utils/periods.formatters';

class CalendarInlineController {
  constructor($scope) {
    'ngInject';
    this.scope = $scope;
  }

  $onInit() {
    this.refreshDate();
    this.scope.$watch(() => this.date, () => {
      if (this.date.getTime() === this.oldDate.getTime()) return;
      this.refreshDate();
    });
  }

  refreshDate() {
    this.month = this.date.getMonth();
    this.year = this.date.getFullYear();
    this.options = this._initOptions();
    this.oldDate = this.date;
  }

  _initOptions() {
    let dateToInsert = {
      year: this.year,
      month: this.month,
      day: 1,
    };
    let option = {
      id: this.id,
      displayYear: false,
      todayHighlight: true,
      language: 'es',
      defaultViewDate: dateToInsert,
    };

    return option;
  }

  onDayRender({ date }) {
    let dayInEvents = this.findDayInEvents(date);
    return formatters.getDayWithContent(date, dayInEvents);
  }

  findDayInEvents(date) {
    let day = this.events.filter((event) => moment(event.day).isSame(date));
    return day;
  }
}

export default CalendarInlineController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInline/calendarInline.controller.js